import { HttpClient, URL_API } from "../../network";

type TUser = {};

class UserServiceApi extends HttpClient {
  getListUser = async (params: TParams & { phone?: string }) => {
    const data = await this.instance.get(URL_API.USER.GET_LIST, {
      params,
    });
    return data;
  };

  createUser = async (dataCreate: any) => {
    const { data } = await this.instance.post(URL_API.USER.CREATE, dataCreate);
    return data;
  };

  updateUser = async (dataUpdate: any) => {
    const { data } = await this.instance.put(
      URL_API.USER.UPDATE + `${dataUpdate?._id}`,
      dataUpdate
    );
    return data;
  };

  getListRestrictedUser = async (params: TParams) => {
    const data = await this.instance.get(URL_API.USER.GET_LIST_RESTRICTED, {
      params,
    });
    return data;
  };

  getListAdmins = async (params: TParams & { role_names?: string[] }) => {
    const data = await this.instance.get("/v1/admins", {
      params,
    });
    return data;
  };

  getUserDetail = async (id: string) => {
    const { data } = await this.instance.get(URL_API.USER.DETAIL + id);
    return data;
  };

  topUpByUser = async ({
    user_id,
    amount,
    // card_id,
    description,
  }: {
    user_id: string;
    amount: number;
    // card_id: string;
    description: string;
  }) => {
    const { data } = await this.instance.post(URL_API.USER.TOP_UP, {
      user_id,
      amount,
      // card_id,
      description,
    });
    return data;
  };

  refundByTransaction = async ({
    user_id,
    amount,
    transaction_id,
    description,
  }: {
    user_id: string;
    amount: number;
    transaction_id: string;
    description: string;
  }) => {
    const { data } = await this.instance.post(URL_API.PAYMENTS.REFUND, {
      user_id,
      amount,
      transaction_id,
      description,
    });
    return data;
  };
}

export const UserService = new UserServiceApi();
